import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/users',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'settings.users',
        },
        children: [
            {
                path: '',
                name: 'UserList',
                component: () => import('./views/UserList.vue'),
            },
            {
                path: 'create',
                name: 'UserCreate',
                component: () => import('./views/UserCreate.vue'),
                meta: {
                    moduleKey: 'settings.users',
                },
            },
            {
                path: ':id',
                name: 'UserDetail',
                component: () => import('./views/UserDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes
